import { render } from "./DuplicateDetection.vue?vue&type=template&id=66f0a351&scoped=true"
import script from "./DuplicateDetection.vue?vue&type=script&lang=js"
export * from "./DuplicateDetection.vue?vue&type=script&lang=js"

import "./DuplicateDetection.vue?vue&type=style&index=0&id=66f0a351&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f0a351"]])

export default __exports__